<tech-simulation-init-modelportfolio></tech-simulation-init-modelportfolio>
<tech-simulation-init-bars></tech-simulation-init-bars>
